import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import qs from "qs";
import { apiUrlB2B, UFOODX_BASE_URL } from "../../utils/constants";
import { axiosInstance, isEmptyData, cleanText, authHeaders } from "../../utils/helper";
import {
    tableNumberAuto,
    setOrder,
    getOrderTypeOptions,
} from "../../store/reducers/order";
import { setCompany } from "../../store/reducers/ufood-x/company";
import { useParams } from "react-router-dom";
import { handleGetStoreDetail } from "../../store/reducers/outlet";
import useNavigation from '../../hook/useNavigation';
import useToast from '../../components/Toast';

const useRedirectQR = () => {
    const dispatch = useDispatch();

    const company = useSelector((store) => store?.company);
    const { details: outlet } = useSelector((store) => store?.outlet);
    const { orderTypeOptions } = useSelector((store) => store?.order);

    const { slug } = useParams();

    const navigate = useNavigation();
    const { showToast } = useToast();

    const url = new URL(window.location.href);

    const companyUrl = url.origin;
    const tableNumber = url.searchParams.get("table_number");
    const auto = url.searchParams.get("auto");

    const getCompany = async () => {
        if (company?.companyID) {
            return {
                companyId: company?.companyID,
                brandId: company?.brandId,
            };
        }

        const res = await axiosInstance.post(
            `${apiUrlB2B}auth-ufoodx/indentify-company`,
            qs.stringify({ companyUrl },
            authHeaders()
            )
        );

        const data = res?.data?.data;

        if (!data) {
            throw new Error("Company tidak ditemukan");
        }

        const companyData = {
            companyID: data?.companyId,
            companyURL: data?.companyURL,
            companyName: data?.companyName,
            companyLogo: data?.companyLogo,
            brandId: data?.brandId,
        };

        await dispatch(setCompany(companyData));

        return {
            companyId: companyData?.companyID,
            brandId: companyData?.brandId,
        };
    };

    const getOutlet = async (brandId) => {
        if (outlet?.storeID && outlet?.storeSlug === slug) {
            return outlet?.storeID;
        }

        const data = await dispatch(
            handleGetStoreDetail({
                brandID: brandId,
                storeID: slug,
            })
        ).unwrap();

        return data?.storeID;
    };

    const setDineIn = async (outletID) => {
        let orderTypes = orderTypeOptions;

        if (!orderTypes?.length) {
            const res = await dispatch(
                getOrderTypeOptions({
                    storeID: outletID,
                })
            ).unwrap();

            orderTypes = res?.data;
        }

        const selectedOrderType = orderTypes?.find(
            (item) => cleanText(item?.av_name) === "dinein"
        );

        if (selectedOrderType) {
            await dispatch(setOrder({ selectedOrderType }));
        }
    };

    const handleQR = async () => {
        const isAuto = auto === "true";

        try {
            const { companyId, brandId } = await getCompany();

            const outletID = await getOutlet(brandId);

            const payload = {
                companyId: Number(companyId),
                outletId: Number(outletID),
                brandId: Number(brandId),
            };

            if (!isAuto) {
                payload.tableNumber = Number(tableNumber);
            }

            try {
                await dispatch(tableNumberAuto(payload)).unwrap();
            } catch (error) {
                const message = isAuto
                    ? "Maaf ada kesalahan QR Code"
                    : "Nomor Meja tidak tersedia";

                return showToast("error", message, 2000).then(() =>
                    navigate.push(UFOODX_BASE_URL)
                );
            }

            await setDineIn(outletID);

        } catch (error) {
            console.log("QR Error:", error);
        }
    };

    useEffect(() => {
        if (auto === "true" || tableNumber) {
            handleQR();
        }
    }, []);
};

export default useRedirectQR;